import {Loader} from '../components/UI/Loader';

export const FullScreenLoader = ({text}) => (
	<div className={'d-flex flex-column align-c-center vh-100 vw-100 bg-c-main-gradient'}>
		{text}
		<Loader className={'bg-rgba-black'}/>
	</div>
)